import React from 'react';
import { Rocket, TrendingUp, Users, Handshake } from 'lucide-react';

const reasons = [
  {
    icon: Rocket,
    title: 'Future-Ready Architecture',
    description: 'We build systems designed to scale and adapt as your business grows, using cutting-edge technologies and best practices.'
  },
  {
    icon: TrendingUp,
    title: 'Performance-Driven Development',
    description: 'Every solution is optimized for speed, efficiency, and reliability to deliver measurable business results.'
  },
  {
    icon: Users,
    title: 'Transparent Collaboration',
    description: 'Clear communication, regular updates, and collaborative approach throughout the development lifecycle.'
  },
  {
    icon: Handshake,
    title: 'Long-Term Partnership',
    description: "We're invested in your success, providing ongoing support and guidance beyond project completion."
  }
];

const WhyChooseUs = () => {
  return (
    <section id="why-choose" className="relative py-32 px-6" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto">
        <div className="section-divider mb-20"></div>
        
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl font-bold mb-4" data-testid="why-choose-title">Why Choose Jupiter Cosmic</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Partner with a team that's committed to your success
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div 
                key={index}
                className="glass-card p-8 border-l-2 border-l-transparent hover:border-l-[#00E5FF] transition-all"
                data-aos="zoom-in"
                data-aos-delay={index * 100}
                data-testid={`reason-card-${index}`}
              >
                <div className="flex items-start space-x-4">
                  <div className="p-3 rounded-lg bg-gradient-to-br from-[#00E5FF]/20 to-[#1F3C88]/20 flex-shrink-0">
                    <Icon className="w-6 h-6 text-[#00E5FF]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-3" data-testid={`reason-title-${index}`}>{reason.title}</h3>
                    <p className="text-gray-400 leading-relaxed">{reason.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
